import { mapGetters, mapActions } from "vuex";

// Show banner from 2026-08-02 00:00 local time
const BANNER_VISIBLE_FROM = new Date(2026, 7, 2, 0, 0, 0);

export default {
	name: "course-banner",
	props: ["current"],
	data() {
		return {
			show: false,
			href: "https://genius.space/online_education/early/",
		};
	},
	computed: {
		...mapGetters({}),
	},
	created() {
		this.updateVisibility();
	},
	methods: {
		...mapActions({}),
		updateVisibility() {
			const courseOk = !!(this.current && (this.current.id == 771 || this.current.id == 784));
			const dateOk = Date.now() >= BANNER_VISIBLE_FROM.getTime();
			this.show = courseOk && dateOk;
		},
	},
	watch: {
		current() {
			this.updateVisibility();
		},
	},
};
